import { collectionData, docData, Firestore } from '@angular/fire/firestore';
import {
  addDoc,
  collection, CollectionReference, deleteDoc,
  doc, DocumentData, getDocs, query, updateDoc, where
} from '@firebase/firestore';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserEvaluation } from 'src/app/interfaces/firebase/user-evaluation.interface';

@Injectable({
  providedIn: 'root'
})
export class UserEvaluationService {
  private table = 'user_evaluations'
  private collectionRef: CollectionReference<DocumentData>;

  constructor(private readonly firestore: Firestore) {
    this.collectionRef = collection(this.firestore, this.table);
  }

  getAll() {
    return collectionData(this.collectionRef, {
      idField: 'id',
    }) as Observable<UserEvaluation[]>;
  }

  get(id: string) {
    const docRef = doc(this.firestore, `${this.table}/${id}`);
    return docData(docRef, { idField: 'id' });
  }

  create(user: UserEvaluation) {
    return addDoc(this.collectionRef, user);
  }

  update(user: UserEvaluation) {
    const docRef = doc(
      this.firestore,
      `${this.table}/${user.id}`
    );
    return updateDoc(docRef, { ...user });
  }

  delete(id: string) {
    const docRef = doc(this.firestore, `${this.table}/${id}`);
    return deleteDoc(docRef);
  }

  async downloadDataFromUser(user_id: string) {
    const q = query(
      collection(this.firestore, this.table),
      where("user_id", "==", user_id),
    );
    const querySnapshot = await getDocs(q);
    const docs = []
    querySnapshot.forEach((doc) => {
      docs.push({
        _id: doc.id,
        ...doc.data()
      })
    });
    return docs;
  }

}
